// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OZBtV","content":"styles_content__2sF2T"};